<template>
  <div v-if="!item.deleted">
    <template
      v-if="
        hasOneShowingChild(item.nodes || [], item) && (!onlyOneChild.nodes || onlyOneChild.noShowingChildren) && !item.alwaysShow
      "
    >
      <app-link v-if="onlyOneChild.tag" :to="'/' + onlyOneChild.tag">
        <el-menu-item :index="'/' + onlyOneChild.tag" :class="{ 'submenu-title-noDropdown': !isNest }">
          <item :icon="onlyOneChild.icon || item.icon" :title="onlyOneChild.text" />
        </el-menu-item>
      </app-link>
    </template>

    <el-submenu v-else ref="subMenu" :index="'/' + item.tag" popper-append-to-body>
      <template slot="title">
        <item v-if="item.text" :icon="item.icon" :title="item.text" />
      </template>
      <sidebar-item v-for="child in item.nodes" :key="child.code" :is-nest="true" :item="child" class="nest-menu" />
    </el-submenu>
  </div>
</template>

<script>
import Item from './Item';
import AppLink from './Link';

export default {
  name: 'SidebarItem',
  components: { Item, AppLink },
  props: {
    // route object
    item: {
      type: Object,
      required: true
    },
    isNest: {
      type: Boolean,
      default: false
    }
  },
  data() {
    // To fix https://github.com/PanJiaChen/vue-admin-template/issues/237
    this.onlyOneChild = null;
    return {};
  },
  methods: {
    hasOneShowingChild(children = [], parent) {
      const showingChildren = children.filter(item => {
        if (item.deleted) {
          return false;
        } else {
          // Temp set(will be used if only has one showing child)
          this.onlyOneChild = item;
          return true;
        }
      });

      // When there is only one child router, the child router is displayed by default
      if (showingChildren.length === 1) {
        return true;
      }

      // Show parent if there are no child router to display
      if (showingChildren.length === 0) {
        this.onlyOneChild = { ...parent, path: '', noShowingChildren: true };
        return true;
      }

      return false;
    }
  }
};
</script>
